import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { DteEmitido } from "../models/Dte/DteEmitido";
import { Response } from "src/app/shared/models/Response";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PagedResponse } from "../shared/models/PagedResponse";
import { Page } from "../shared/models/Page";
import { DteFilter } from "../models/Dte/DteFilter";
import { DteEmitidoFile } from "../models/Dte/DteEmitidoFile";
import { Traza } from "../models/Traza";
import { NotaCredito } from "../models/NotaCredito";
import { DetalleDte } from "../models/Dte/DetalleDte";
import { Receptor } from "../models/Receptor/Receptor";
import { ReferenciaDte } from "../models/Dte/ReferenciaDte";
import { DteRecibidoFilter } from "../models/Dte/DteRecibidoFilter";
import { DteRecibido } from "../models/Dte/DteRecibido";
import { AcuseRecibo } from "../models/Dte/AcuseRecibo";
import { Conciliacion } from "../models/Dte/Conciliacion";
import { AcuseReciboMasivo } from "../models/Dte/AcuseReciboMasivo";
import { CorreoIntercambioSii } from "../models/Emisor/CorreoIntercambioSii";

interface CorreoIntercambioSiiResponse extends Partial<CorreoIntercambioSii> {
	success?: boolean;
	ambiente?: number;
}

@Injectable({
	providedIn: "root",
})
export class DocumentosRecibidosService {
	private REST_API_SERVER = environment.backend_server + "/DteRecibido";
	private REST_API_SERVER_TEMPLATE = environment.backend_server + "/Impresion";
	private auth = {};
	constructor(private http: HttpClient) {}

	public getData(emisorId: string): Observable<Response<DteRecibido[]>> {
		return this.http.get<Response<DteRecibido[]>>(this.REST_API_SERVER + "/list?emisorId=" + emisorId);
	}

	public getDataByPage(filtro: DteRecibidoFilter, page: Page): Observable<PagedResponse<DteRecibido>> {
		let stringEstadoSii = filtro.estadoSii ? "&estadoSii=" + filtro.estadoSii : "";
		return this.http.get<PagedResponse<DteRecibido>>(
			this.REST_API_SERVER +
				"/list/filter?emisorId=" +
				filtro.emisorId +
				"&NombreProveedor=" +
				(filtro.nombreProveedor != undefined ? filtro.nombreProveedor : "") +
				"&Estado=" +
				(filtro.estado != undefined ? filtro.estado : "") +
				"&Folio=" +
				(filtro.folio != undefined ? filtro.folio : "") +
				"&MontoTotal=" +
				(filtro.montoTotal != undefined ? filtro.montoTotal : "") +
				"&RutProveedor=" +
				(filtro.rutProveedor != undefined ? filtro.rutProveedor : "") +
				"&EstadoRespuestaId=" +
				(filtro.respuestaEstadoDte != undefined ? filtro.respuestaEstadoDte : "") +
				"&tipoDteId=" +
				filtro.tipoDteId +
				"&fechaEmisionDesde=" +
				(filtro.fechaDesde != undefined ? filtro.fechaDesde : "") +
				"&fechaEmisionHasta=" +
				(filtro.fechaHasta != undefined ? filtro.fechaHasta : "") +
				"&fechaVencimientoAcuseDesde=" +
				(filtro.fechaVencimientoDesde != undefined ? filtro.fechaVencimientoDesde : "") +
				"&fechaVencimientoAcuseHasta=" +
				(filtro.fechaVencimientoHasta != undefined ? filtro.fechaVencimientoHasta : "") +
				"&fechaRecepcionSiiDesde=" +
				(filtro.fechaRecepcionDesde != undefined ? filtro.fechaRecepcionDesde : "") +
				"&fechaRecepcionSiiHasta=" +
				(filtro.fechaRecepcionHasta != undefined ? filtro.fechaRecepcionHasta : "") +
				"&Nulos=" +
				(filtro.nulos != undefined ? filtro.nulos : "") +
				"&TieneNC=" +
				(filtro.tieneNC != undefined ? filtro.tieneNC : "") +
				"&Cedida=" +
				(filtro.cedida != undefined ? filtro.cedida : "") +
				"&WithPDF=" +
				(filtro.withPDF != undefined ? filtro.withPDF : "") +
				"&pageNumber=" +
				page.pageNumber +
				"&pageSize=" +
				page.pageSize
		);
	}

	public getDataByPageOnRVD(rvdId: string, emisorId: string, page: Page) {
		return this.http.get<PagedResponse<DteEmitido>>(this.REST_API_SERVER + "/list/filterbyrvd?registroVentaDiarioId=" + rvdId + "&emisorId=" + emisorId + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize);
	}

	public getXml(dteId: string): Observable<Response<DteEmitidoFile>> {
		return this.http.get<Response<DteEmitidoFile>>(this.REST_API_SERVER + "/xml?dteId=" + dteId);
	}

	public getPdf(dteId: string, cedible: boolean): Observable<Response<string>> {
		var x = this.REST_API_SERVER_TEMPLATE + "/pdfProveedores/" + dteId + "/" + cedible;
		return this.http.get<Response<string>>(x);
	}

	public getZip(request): Observable<Blob> {
		return this.http.post(this.REST_API_SERVER + "/download-zip",request, { responseType: 'blob' });
	}

	public getTrace(dteId: string): Observable<Response<Traza[]>> {
		return this.http.get<Response<Traza[]>>(this.REST_API_SERVER + "/trazas?dteId=" + dteId);
	}

	public acuseRecibo(acuse: AcuseRecibo): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/acuseRecibo", acuse);
	}

	public conciliacion(conciliacion: Conciliacion): Observable<Response<string>> {
		return this.http.post<Response<string>>(this.REST_API_SERVER + "/conciliacion", conciliacion);
	}
	public conciliacionMensual(conciliacion: Conciliacion): Observable<Response<string>> {
		return this.http.post<Response<string>>(this.REST_API_SERVER + "/conciliacionmensual", conciliacion);
	}

	public refreshSiiExchangeEmail(emisorId: string): Observable<CorreoIntercambioSii> {
		return this.http
			.post<CorreoIntercambioSiiResponse>(`${environment.backend_server}/company/${emisorId}/sii-exchange-email/refresh`, null)
			.pipe(map(result => this.normalizeSiiExchangeEmail(result)));
	}

	public updateSiiExchangeEmail(emisorId: string): Observable<CorreoIntercambioSii> {
		return this.http
			.post<CorreoIntercambioSiiResponse>(`${environment.backend_server}/company/${emisorId}/sii-exchange-email/update`, null)
			.pipe(map(result => this.normalizeSiiExchangeEmail(result)));
	}

	private normalizeSiiExchangeEmail(result: CorreoIntercambioSiiResponse): CorreoIntercambioSii {
		const expectedEmail = result.expectedEmail || "intercambio@chilesystems.com";
		const email = result.email && result.email.trim();
		const available = result.available !== undefined ? result.available : !!email;
		const verifiedInSii = result.verifiedInSii !== undefined
			? result.verifiedInSii
			: result.success === true;
		const isConfigured = result.isConfigured !== undefined
			? result.isConfigured
			: available && !!email && email.toLowerCase() === expectedEmail.toLowerCase();

		return {
			available,
			email,
			displayEmail: result.displayEmail || (available ? email : "No disponible"),
			catalogUrl: result.catalogUrl,
			updatedAt: result.updatedAt,
			verifiedInSii,
			environment: result.environment || (result.ambiente === 1 ? "Producción" : "Certificación"),
			message: result.message || "",
			expectedEmail,
			isConfigured,
		};
	}

	public acuseMasivo(model: AcuseReciboMasivo): Observable<Response<any>> {
		return this.http.post<Response<any>>(this.REST_API_SERVER + "/acuse/masivo", model);
	}
}
